export class EmployeesTrainingPlanConstants{

    //Spinner message
    public static readonly EmployeeTrainingPlan_SaveInProgress :  string = 'Training Plan Save is in progress';
    public static readonly UpdateTrainingPlanReview :  string = 'Training Plan Review updated successfully';

    // Toaster Messages and Severity
    public static readonly Severity_Success: string = 'success';
    public static readonly Severity_Info: string = 'info';
    public static readonly Severity_Err: string = 'error';
    public static readonly Severity_Warning: string = 'warn';

    //Status of training Item
    public static readonly TrainingPlan_StatusActive: number = 0;
    public static readonly TrainingPlan_StatusNameActive: string = "Active";
    public static readonly TrainingPlan_StatusRemoved: number = 1;
    public static readonly TrainingPlan_StatusNameRemoved: string = "Removed";

    //Core/Elective of training Item
    public static readonly TrainingPlan_Core: number = 0;
    public static readonly TrainingPlan_CoreName: string = "Core";
    public static readonly TrainingPlan_Elective: number = 1;
    public static readonly TrainingPlan_ElectiveName: string = "Elective";
    public static readonly TrainingPlan_NotApplicable: number = 2;
    public static readonly TrainingPlan_NotApplicableName: string = "N/A";

    //Tab indicies
    public static readonly TrainingPlan_Menu_Document_Tab_Index: number = 1;
    public static readonly TrainingPlan_Menu_Course_Tab_Index: number = 2;

    //Type of training Item
    public static readonly EmployeeTraining_DocumentType: number = 0;
    public static readonly EmployeeTraining_CourseType: number = 1;

    // confirmation Messages
    public static readonly TrainingPlan_Slider_Confirmation_Header: string =
    'Confirmation';
    public static readonly TrainingPlan_Slider_Confirmation_Text: string =
    'Any unsaved change will be lost when closing the screen. Do you want to continue?';


    //Error Messages
    public static readonly AtleastOneTrainingItem_ShouldBeSelected: string = "At least one item must be selected in the search results for addition in the Training Plan Requirement.";
    public static readonly LinkedDocument_AlreadyExists_InTrainingPlan: string = "The following Documents are already in the Training Plan, it is not possible to add them again: DocumentNumbers";
    public static readonly LinkedCourse_AlreadyExists_InTrainingPlan: string = "The following Courses are already a in the Training Plan, it is not possible to add them again: CourseNumbers";
    public static readonly LinkedItems_AlreadyExists_InTrainingPlan: string = "The following Items are already a in the Training Plan, it is not possible to add them again: ItemNumbers";
    public static readonly Selected_Documentscopes_Not_Matching_Error_Message: string = "The following Documents cannot be linked to this Training Plan as they are associated with an incompatible eQMS Scope: DocumentNumbers";
    public static readonly Selected_CourseScopes_Not_Matching_Error_Message: string = "The following Courses cannot be linked to this Training Plan as they are associated with an incompatible eQMS Scope: CourseNumbers";
    public static readonly TrainingPlan_FailureToUpdate: string = "The update operation was not successfull";
    public static readonly TrainingPlan_WarningMessageForSameStatusTrainingItem: string = "The following Training Items have not been updated because they are already in the selected Status: TrainingItemCodes"
    public static readonly TrainingPlan_WarningMessageForRemovedStatusTrainingItem : string = 
    "The following Training Items have not been updated because they are in Status Removed:TrainingItemCodes";
    public static readonly TrainingPlan_WarningMessageForSameCoreOrElectiveTrainingItem : string = 
    "The following Training Items have not been updated because they are already in the selected Core/Elective: TrainingItemCodes"
    public static readonly Selected_TrainingItemGroupscopes_Not_Matching_Error_Message: string = "At least one of the selected Training Item Groups cannot be linked to this Training Plan Requirement as they are associated with an incompatible eQMS Scope: TrainingItemGroupNumbers";
    public static readonly TrainingPlan_updatedSuccesfully: string = "Training Plan Updated for: ";

    //Warning Messages
    public static readonly TrainingPlan_Warning_TrainingItemAlreadyPresentMessage: string = 'At least one Training Item in the Group already belongs to the User Training Plan and has not been added: TrainingItems'

    // features
    public static readonly MyEmployee_TrainingPlan_Feature: string = 'myEmployeeTrainingPlan';
    public static readonly EmployeeTrainingPlanDocumentDetails : string = 'Employee Training Plan Document Details'
    public static readonly EmployeeTrainingPlanCourseDetails : string = 'Employee Training Plan Course Details'
}